/**
 * MV2-1204 - o financial devolve nfeDanfseUrls como lista vazia (nunca null)
 * quando a NF não tem DANFSe; com `??` o fallback para nfeUrls nunca rodava e o
 * botão de download ficava desabilitado mesmo com a NF emitida.
 */
export const resolveNfeUrls = (
  danfseUrls?: string[] | null,
  nfeUrls?: string[] | null,
): string[] => {
  if (danfseUrls?.length) {
    return danfseUrls;
  }
  return nfeUrls ?? [];
};
